import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PaginationProps {
    totalItems: number;
    itemsPerPage: number;
    onPageChange?: (page: number) => void;
    noLink?: boolean
}

const Pagination: React.FC<PaginationProps> = ({ totalItems, itemsPerPage, onPageChange, noLink= false }) => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [currentPage, setCurrentPage] = useState<number>(parseInt(queryParams.get('p') || '1', 10));

    const buildUrl = (page: number): string => {

        if ( noLink ) {
            return '#';
        }

        queryParams.set('p', page.toString());
        return `${location.pathname}?${queryParams.toString()}`;

    };

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const handlePageChange = (page: number) => {
        if (onPageChange) {
            onPageChange(page);
        }
        setCurrentPage(page); // Update currentPage state
    };

    const renderPageNumbers = (): JSX.Element[] => {
        const pageNumbers: JSX.Element[] = [];

        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(
                <li key={i} className={currentPage === i ? 'active' : ''}>
                    {currentPage === i ? (
                        <strong>{i}</strong>
                    ) : (
                        <a href={buildUrl(i)} onClick={() => handlePageChange(i)}>
                            {i}
                        </a>
                    )}
                </li>
            );
        }

        return pageNumbers;
    };

    return (
        <div className="pager clear" style={{width: "100%"}}>
            <p>
                Kokku: {totalItems} <span>|</span> Kuvan: {((currentPage - 1) * itemsPerPage) + 1}-{Math.min(currentPage * itemsPerPage, totalItems)}
            </p>
            <ul>
                <li className={currentPage === 1 ? 'first' : 'first'}>
                    {currentPage === 1 ? (
                        <span>Esimene</span>
                    ) : (
                        <a href={buildUrl(1)} onClick={() => handlePageChange(1)}>
                            Esimene
                        </a>
                    )}
                </li>
                <li className={currentPage === 1 ? 'back' : 'back'}>
                    {currentPage === 1 ? (
                        <span>Eelmine</span>
                    ) : (
                        <a href={buildUrl(Math.max(currentPage - 1, 1))} onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}>
                            Eelmine
                        </a>
                    )}
                </li>
                {renderPageNumbers()}
                <li className={currentPage === totalPages ? 'next' : 'next'}>
                    {currentPage === totalPages ? (
                        <span>Järgmine</span>
                    ) : (
                        <a href={buildUrl(Math.min(currentPage + 1, totalPages))} onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}>
                            Järgmine
                        </a>
                    )}
                </li>
                <li className={currentPage === totalPages ? 'last' : 'last'}>
                    {currentPage === totalPages ? (
                        <span>Viimane</span>
                    ) : (
                        <a href={buildUrl(totalPages)} onClick={() => handlePageChange(totalPages)}>
                            Viimane
                        </a>
                    )}
                </li>
            </ul>
        </div>
    );
};

export default Pagination;